<!-- 新增现货仓储 -->
<template>
    <div class="content-panel">
        <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
            <el-col :span="20">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/admin/stock'}">{{msg('货运管理')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{msg('新增现货订单')}}</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="10"  class="ctrl-wrap">
            <el-form ref="form" :model="stock" label-width="100px" style="margin:0 20px">
                <h3 style="padding:0px; margin:0px;">必填项</h3>
                <el-row type="flex" justify="start" style="flex-wrap: wrap;">
                    <el-col :xs="24" :sm="12">
                        <el-form-item :label="msg('收件仓库')">
                            <el-select v-model="stock.storeId" placeholder="请选择" size="small">
                                <el-option
                                    v-for="item in stores"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item :label="msg('运输方式')">
                            <el-select v-model="stock.transport"  placeholder="供参考，实际以出货为准" size="small">
                                <el-option
                                    v-for="item in dicts.transportTypeInout"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- 新增现货仓储选填项 -->
                <h3 style="padding:0px; margin:0px;">选填项</h3>
                <el-form-item :label="msg('包号')">
                    <el-col :xs="24" :sm="12">
                        <el-input v-model.trim="stock.bagCode" :placeholder="msg('可填可不填，不填由系统生成')" size="small"></el-input>
                    </el-col>
                    <el-col :xs="24" :sm="12" style="text-align:right;">
                        <el-button type="primary" size="large"  @click="onSubmit()"><i class="el-icon-check"></i><span>{{msg('确认新增')}}</span></el-button>
                    </el-col>
                </el-form-item>
                <!-- end -->
                <h3 style="padding:0px;margin:0px;">订单</h3>
                <div v-for="(detail, idx) in stock.details" :key="idx"
                    style="margin-top:15px; margin-bottom:15px;"
                >
                    <el-row type="flex" justify="start" style="flex-wrap: wrap;" >
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <el-form-item style="margin-bottom:3px;" :label="msg('订单编号')" label-width="100px" >
                                <el-input v-model="detail.code" placeholder="请输入订单单号" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <el-form-item style="margin-bottom:3px;" :label="msg('补货单号')" label-width="100px" >
                                <el-input v-model="detail.inCode" placeholder="请输入补货单号" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <el-form-item style="margin-bottom:3px;" :label="msg('SKU')" label-width="100px" >
                                <el-input v-model="detail.sku" placeholder="请输入SKU" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <el-form-item style="margin-bottom:3px;" :label="msg('货号')" label-width="100px" >
                                <el-input v-model="detail.variationSku" placeholder="请输入货号" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <el-form-item style="margin-bottom:3px;" :label="msg('规格')" label-width="100px" >
                                <el-input v-model="detail.productSpec" placeholder="请输入规格" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <el-form-item style="margin-bottom:3px;" :label="msg('产品描述')" label-width="100px" >
                                <el-input v-model="detail.productTitle" placeholder="请输入产品描述" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <el-form-item style="margin-bottom:3px;" :label="msg('货单备注')" label-width="100px" >
                                <el-input v-model="detail.remark" placeholder="请输入货单备注" size="small"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="6">
                            <el-form-item style="margin-bottom:3px;" :label="msg('件数')" label-width="100px" >
                                <div style="display:flex; align-items: center;">
                                    <el-input v-model="detail.productQty"  placeholder="请输入件数" size="small"></el-input>
                                    <el-tooltip class="item" effect="dark" content="复制添加" placement="top-start">
                                        <el-button size='mini' plain type="success" @click="addDetails(detail)"
                                            style="margin-left:8px;"
                                        >
                                            <i class="el-icon-document-copy"></i>
                                        </el-button>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                                        <el-button size='mini' plain type="danger" @click="deleteDetail(idx)"
                                            style="margin-left:4px;"
                                        >
                                            <i class="el-icon-delete-solid"></i>
                                        </el-button>
                                    </el-tooltip>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            
            </el-form>

        </el-row>
    </div>
</template>

<script>
export default {
    name: "StockAddStore",
    data(){
        return {
            stores: null,
            stock: {
                storeId: null,
                storeName: null,
                transport: null,
                bagCode: null,
                expCompany: null,
                details:[{
                    code: null,
                    productQty: 1,
                    sku: null,
                    variationSku: null,
                    productSpec: null,
                    productTitle: null,
                    remark: null,
                    inCode: null
                }]
            },
        }
    },
    mounted(){
        this.getStores();
        this.initCode();
    },
    watch:{
        $route(){
            let routeName = this.$route.name;
            if(routeName == "stock-add-store"){
                //跳转到该页面后需要进行的操作
                if(!this.stores){
                    this.getStores();
                }
                if(!this.stock.bagCode){
                    this.initCode();
                }
            }
        }
    },
    methods:{
        init(){
            this.stock = {
                storeId: null,
                storeName: null,
                transport: null,
                bagCode: null,
                expCompany: null,
                details:[{
                    code: null,
                    productQty: 1,
                    sku: null,
                    variationSku: null,
                    productSpec: null,
                    productTitle: null,
                    remark: null,
                    inCode: null
                }]
            };
        },
        
        async initCode(){
            let result = await this.$axios.get(this.$kit.api.stock.initCode);
            if(result.status){
                let data = result.data;
                this.stock.bagCode = data.bagCode;
                this.stock.details[0].code = data.code;
            }
        },
        getStores(){
            this.$axios.post(this.$kit.api.store.listUsed)
                .then((result)=> {
                    if(result.status){
                        this.stores = result.data;
                    }
                });
        },
        async onSubmit(){
            var _this = this;
            if(!this.stock.storeId){
                this.$message(this.msg('收件仓库不能为空'));
                return;
            }
            if(this.stock.details.length <= 0){
                this.$message(this.msg('订单信息不能为空'));
                return;
            }
            if(!this.stock.transport){
                this.$message(this.msg('运输方式不能为空'));
                return;
            }
            let isAll = true;
            this.stock.details.forEach(e => {
                if(!e.code || !e.productTitle || !e.productSpec || e.productQty <= 0){
                    isAll = false;
                }
            })
            if(!isAll){
                this.$message(this.msg('产品描述，规格，单号不能为空，数量不能小于1'));
                return;
            }

            // window.stores = this.stores;
            // window.stock = this.stock;
            // console.log(this.stores, this.stock.storeId)
            let store = this.stores.find(s => s.id == this.stock.storeId);
            this.stock.storeName = store.name;

            //判断订单编号不能重复
            let codes = this.stock.details.map(e => e.code).join(',');
            let result = await _this.$axios.post(_this.$kit.api.stock.checkCodes,codes);

            if(!result.status){
                _this.$message(_this.msg('单号重复'));
                return;
            }

            let ret1 = await _this.$axios.post(_this.$kit.api.stock.createStore,_this.stock);
            if(ret1.status){
                _this.$message(_this.msg('添加成功'));
                this.init();
                this.initCode();
                return;
            }

            _this.$alert(_this.msg(result.msg),
                 _this.msg('提示'), {
                confirmButtonText: '确定',
            });
        },
        async addDetails(row){
            let result = await this.$axios.get(this.$kit.api.stock.createCode);
            let code = result.data || null;
            let detail = {...row};
            detail.code = result.data;
            this.stock.details.push(detail);
        },
        deleteDetail(idx){
            if(this.stock.details.length>1){
                this.stock.details.splice(idx, 1);
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.xmain .router-tab-page {
    height: calc(100vh - 100px);
}
</style>